export default {
  leader: [{
    id: 1,
    name: '梁云红',
    subject: '总队长（局长）',
    desc: '梁云红，男，汉族，1969年10月出生，在职研究生学历，中共党员。现任上海市消防救援总队（上海市消防救援局）党委副书记、总队长（局长），高级指挥长消防救援衔。'
  }, {
    id: 2,
    name: '王保国',
    subject: '政治委员',
    desc: '王保国，男，汉族，1972年8月出生，在职研究生学历，博士学位，中共党员。现任上海市消防救援总队（上海市消防救援局）党委书记、政治委员，高级指挥长消防救援衔。'
  }, {
    id: 3,
    name: '姜亦山',
    subject: '副总队长（副局长）',
    desc: '姜亦山，男，汉族，1969年8月出生，大学本科学历，中共党员。现任上海市消防救援总队（上海市消防救援局）党委委员、副总队长（副局长），一级指挥长消防救援衔。'
  }, {
    id: 4,
    name: '盖志娟',
    subject: '政治部主任',
    desc: '盖志娟，女，汉族，1971年2月出生，大学本科学历，中共党员。现任上海市消防救援总队（上海市消防救援局）党委委员、政治部主任，一级指挥长消防救援衔。'
  }, {
    id: 5,
    name: '沈渭勇',
    subject: '副总队长（副局长）',
    desc: '沈渭勇，男，汉族，1968年6月出生，在职大学本科学历，中共党员。现任上海市消防救援总队（上海市消防救援局）党委委员、副总队长（副局长），一级指挥长消防救援衔。'
  }, {
    id: 6,
    name: '朱志祥',
    subject: '副总队长（副局长）',
    desc: '朱志祥，男，汉族，1972年9月出生，在职大学本科学历，中共党员。现任上海市消防救援总队（上海市消防救援局）党委委员、副总队长（副局长），一级指挥长消防救援衔。'
  }],
  office: [{
    id: 1,
    name: '办公室',
    desc: '负责机关日常运转，承办信息、保密、密码、信访、档案、政务公开、重要文稿起草、国际合作与交流等工作。承担火灾等灾害事故救援统计分析有关工作。'
  }, {
    id: 2,
    name: '指挥中心',
    desc: '牵头组织总队值班值守工作，接报处理警情、灾情信息。按权限承办国家综合性消防救援队伍力量调动事宜，调度辖区内其他各类消防救援队伍参与处置，协调和指挥调度相关灾害事故处置。负责本市119接处警工作。'
  }, {
    id: 3,
    name: '人事和教育训练处',
    desc: '负责干部人事、劳动工资、退休等有关工作。按权限做好队伍教育训练有关工作，统筹各类培训工作。指导干部队伍建设和人才工作。'
  }, {
    id: 4,
    name: '队务和专职队管理处',
    desc: '负责机构编制和国家消防员人事、劳动工资、退休等有关工作。组织指导队伍正规化建设与管理。统筹负责市、区级政府专职消防队伍规范建设管理工作，指导乡镇（街道）政府专职消防队伍编制、人事和管理教育工作。承担消防员职业技能鉴定有关工作。'
  }, {
    id: 5,
    name: '灭火救援处',
    desc: '承担组织指导灭火救援工作，承担预案编制、战术研究、执勤备勤和业务训练、演练等工作，组织指挥灭火救援行动。组织指导地方政府专职消防队伍执勤训练、灭火救援等业务建设，组织开展联勤联训等工作。'
  }, {
    id: 6,
    name: '特种灾害救援处',
    desc: '承担组织指导地震、地质、洪涝、冰冻、台风等自然灾害应急救援，按规定参与相关调查评估工作，组织参与核生化、爆炸等事故灾难应急处置工作，指挥调度相关救援行动。承担特种灾害救援预案编制、战术研究、执勤备勤和业务训练、演练等工作。负责与地方相关专业应急救援队伍、志愿者队伍建立共训共练、救援合作机制。'
  }, {
    id: 7,
    name: '应急通信和科技处',
    desc: '承担组织指导灾害事故救援行动、重大活动消防安全保卫等应急通信保障工作，负责信息化和应急通信建设。负责制定消防科技发展规划，组织实施需求调研、科技攻关、成果推广等消防科技有关工作。承担组织指导使用领域消防产品质量等监督管理工作。'
  }, {
    id: 8,
    name: '消防监督处',
    desc: '指导队伍依法行使消防监督管理职能，组织指导消防安全责任制落实及检查考核，承担组织指导火灾预防、消防监督执法等有关工作。组织重大活动消防安全保卫工作。统筹基层消防治理工作。'
  }, {
    id: 9,
    name: '火灾调查和新闻宣传处',
    desc: '承担组织指导火灾事故原因调查处理和统计火灾损失等有关工作。指导协调对涉嫌消防安全的犯罪案件移送公安、司法、监察机关查处惩治。组织指导消防宣传教育，承担新闻宣传、新闻发布，负责消防舆论引导和舆情监测应对等工作。'
  }, {
    id: 10,
    name: '政策法规处',
    desc: '组织研究重大政策制度，起草地方性消防法规、政府规章草案，制定执法制度，根据职责权限拟订相关地方消防技术标准。组织指导编制消防规划并监督实施。指导执法规范化建设，开展内部执法监督，组织开展普法工作，承担重大行政决策事项、规范性文件合法性审查和行政复议、行政应诉等工作。负责消防设施维护保养检测、消防安全评估等消防技术服务机构和注册消防工程师、消防设施操作员等消防执业资格管理有关工作。'
  }, {
    id: 11,
    name: '后勤装备处',
    desc: '承担组织指导灭火救援装备建设、营房建设、被装保障、伙食管理、职业健康、物资及油料供应、车辆及牌证管理等工作。承担组织指导灾害事故救援行动遂行保障工作。'
  }, {
    id: 12,
    name: '财务审计处',
    desc: '承担组织指导队伍预算、核算、决算及资金支付等财务管理工作。组织指导资产管理工作。组织指导队伍内部审计工作。'
  }, {
    id: 13,
    name: '机关党委（党建指导处）',
    desc: '负责总队机关及直属单位党的建设，领导机关群团组织工作。承担组织指导队伍党的建设和思想政治建设等工作。机关党委设立机关纪委，承担机关及直属单位纪检、党风廉政建设有关工作。'
  }, {
    id: 14,
    name: '纪检室（巡察工作领导小组办公室）',
    desc: '履行监督执纪问责职责。承担队伍内部巡察工作。'
  }, {
    id: 15,
    name: '政治部',
    desc: '统筹负责党的建设、思想政治建设、正规化建设和干部、消防员队伍建设。日常工作由人事和教育训练处、队务和专职队管理处、机关党委（党建指导处）等承担。'
  }]
}